<template>
  <!-- 商户信息管理，用于通联支付对接 -->
  <div class="">
    <list-page>
      <search-condition @search="resetSearch" :show-search="true" >
        <template #default>
          <el-input v-model="searchInfo.deviceName" placeholder="请输入查询关键字" @keydown.enter="resetSearch">
            <template #prefix>关键字</template>
          </el-input>
          <el-select v-model="searchInfo.siteId" placeholder="请选择工地" clearable filterable>
            <template #prefix>工地名称</template>
            <el-option v-for="it in siteList" :key="it.id" :label="it.siteName" :value="it.id"></el-option>
          </el-select>
        </template>
        <template #option>
          <page-button el-type="primary" @click="resetSearch">查询</page-button>
          <page-button hasPerm="sys:entrance:add" el-type="success" @click="toEdit({})">新建</page-button>
        </template>
      </search-condition>
      <list-table>
        <yq-table :data="dataList" height="100%" stripe border>
          <yq-table-column label="设备名称" prop="deviceName" min-width="180rem"/>
          <yq-table-column label="工地名称" prop="siteName"/>
          <yq-table-column label="设备编号" prop="deviceSn"/>
          <yq-table-column label="设备类型" prop="deviceType">
            <template v-slot="{row}">
              <c-custom-select v-model="row.deviceType" value="usercode" read-only label="dictName" :data-list="clockDeviceList"/>
            </template>
          </yq-table-column>
          <yq-table-column label="在线状态" prop="deviceType">
            <template v-slot="{row}">
              <el-tag v-if="row.status === '0'" type="success">在线</el-tag>
              <el-tag v-if="row.status === '1'" type="info">离线</el-tag>
            </template>
          </yq-table-column>
          <yq-table-column label="设备状态" prop="isRegister">
            <template v-slot="{row}">
              <el-tag v-if="row.isRegister === '0'" type="success">已注册</el-tag>
              <el-tag v-else>未注册</el-tag>
            </template>
          </yq-table-column>
          <yq-table-column label="操作" prop="options" :align="'center'" fixed="right" width="120rem"
                           :show-overflow-tooltip="false">
            <template v-slot="{row}">
              <table-button-group label="更多操作">
                <table-button hasPerm="sys:entrance:save" @click="toEdit(row)">编辑</table-button>
                <table-button hasPerm="sys:entrance:remove" el-type="danger" message="是否确认删除数据" @click="deleteOne(row.id)">
                  删除
                </table-button>
              </table-button-group>
            </template>
          </yq-table-column>
        </yq-table>
      </list-table>
      <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize"
                 :total-count="searchInfo.totalCount" @onLoad="queryList"/>
    </list-page>
    <el-dialog v-model="showDetail" title="打卡设备信息" dialog-width="1" :close-on-click-modal="false">
      <form-items ref="formItems" :columns="1" label-width="2.4rem" icon-width="0" :data="currentData">
        <form-item label="设备名称" :required="true" name="deviceName" error-message="请输入设备名称">
          <el-input v-model="currentData.deviceName" placeholder="请输入设备名称"/>
        </form-item>
        <form-item label="设备编号" :required="true" name="deviceSn" error-message="请输入设备编号">
          <el-input v-model="currentData.deviceSn" placeholder="请输入设备名称"/>
        </form-item>
        <form-item label="设备类型" :required="true" name="deviceType" error-message="请选择设备类型">
          <c-custom-select v-model="currentData.deviceType" value="userCode" label="dictName" :data-list="clockDeviceList"/>
        </form-item>

        <form-item label="工地名称">
          <el-select v-model="currentData.siteId" placeholder="请选择所属工地">
            <el-option v-for="it in siteList" :key="it.id" :label="it.siteName" :value="it.id"></el-option>
          </el-select>
        </form-item>
      </form-items>
      <div>
        <page-button @click="showDetail = false">取消</page-button>
        <page-button el-type="primary" @click="save">保存</page-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import SearchCondition from "@/components/h5/layout/SearchCondition";
import FormPage from "@/components/h5/layout/FormPage";
import ListTable from "@/components/h5/layout/ListTable.vue";
import ListPage from "@/components/h5/layout/ListPage";
import TableButton from "@/components/h5/button/TableButton";
import TableButtonGroup from "@/components/h5/button/TableButtonGroup.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import Util from "@/util/util";
import {useRoute, useRouter} from "vue-router";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import clockInDeviceApi from "@/api/dz-luqiao/clockInDeviceApi";
import commonLqApi from "@/api/dz-luqiao/luqiaoCommonApi";
import CCustomSelect from "@/views/h5/luqiao/display/c-custom-select.vue";
import commonApi from "@/api/commonApi";
import util from "@/util/util"

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "itemEntranceList",
  components: {
    CCustomSelect,
    YqTableColumn, TableButtonGroup, TableButton, SearchCondition, FormPage, ListTable, ListPage, FormItems, FormItem
  },
  data() {
    return {
      searchInfo: {},
      dataList: [],
      currentData: {},
      showDetail: false,
      siteList: [],
      clockDeviceList: [],
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  async created() {
    if (this.route.query.siteId) {
      this.searchInfo.siteId = this.route.query.siteId;
    }
    this.resetSearch();
    /** 查询工地列表 */
    this.siteList = await commonLqApi.querySiteNoPage()
    this.clockDeviceList = await commonApi.queryDictionaryList("CLOCK_DEVICE", (await util.getUserInfo()).merchantId)
  },
  methods: {
    async queryList() {
      const {records, totalCount} = await clockInDeviceApi.list(this.searchInfo)
      this.dataList = records;
      this.searchInfo.totalCount = totalCount;
    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
    toEdit(data) {
      this.currentData = {...data};
      this.showDetail = true;
    },
    async save() {
      if (this.$refs.formItems) {
        if (!this.$refs.formItems.validCheck()) {
          return;
        }
      }
      await clockInDeviceApi.save(this.currentData)
      this.showDetail = false;
      await this.queryList();
    },
    async deleteOne(id) {
      await clockInDeviceApi.delete(id)
      await this.queryList();
    }
  }
};
</script>

<style lang="scss" scoped>
</style>